import React, { useState } from "react";
import currentAdminContext from "../context/currentAdminContext";
import Admin from "../../entities/Admin";
import User from "../../entities/User";

const CurrentAdminProvider = ({ children }) => {
  // state variables
  const [currentAdmin, setAdmin] = useState(null);

  //some handler
  const login = (data) => {
    const person = data.role === 1 ? new Admin(data) : new User(data);
    setAdmin(person);
  };

  const logout = () => setAdmin(null);

  //context value
  const contextValue = {
    currentAdmin,
    login,
    logout,
  };
  return (
    <currentAdminContext.Provider value={contextValue}>
      {children}
    </currentAdminContext.Provider>
  );
};

export default CurrentAdminProvider;
